import { sort } from "@common/lib/array";
import * as React from "react";
import { type KnowledgeBase } from "../types";
import Item from "./Item";
import { mapCategory } from "./lib";

type Props = {
  activeCategory: KnowledgeBase.Api.ArticleCategory | null;
  articles: KnowledgeBase.Api.Article[];
  categories: KnowledgeBase.Api.ArticleCategory[];
  onArticleClick: (article: KnowledgeBase.Api.Article) => void;
  style: React.CSSProperties;
};
const KnoledgeBaseCategoryAccordion = (props: Props) => {
  const roots = React.useMemo(
    () =>
      sort(
        props.categories.filter((x) => !x.parentArticleCategoryId),
        { key: "sortOrder" }
      ).map((x) => mapCategory(props.categories, x)),
    [props.categories]
  );

  const getIsExpanded = React.useCallback(
    (category: KnowledgeBase.Api.ArticleCategory) => {
      if (!props.activeCategory) return false;

      let currentCategory: KnowledgeBase.Api.ArticleCategory | undefined = props.activeCategory;
      while (currentCategory) {
        if (category.articleCategoryId === currentCategory.articleCategoryId) return true;

        currentCategory = props.categories.find(
          (x) => x.articleCategoryId === currentCategory?.parentArticleCategoryId
        );
      }
      return false;
    },
    [props.activeCategory, props.categories]
  );

  return (
    <div className="knowledge_base_container" style={props.style}>
      {roots.map((x, index) => (
        <Item
          key={x.articleCategoryId}
          articles={props.articles}
          categories={roots}
          category={x}
          getIsExpanded={getIsExpanded}
          index={index}
          level={1}
          onArticleClick={props.onArticleClick}
          style={props.style}
        />
      ))}
    </div>
  );
};
export default KnoledgeBaseCategoryAccordion;
